import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  showLoading() {
    document.getElementById('loading-screen')?.classList.remove('d-none');
  }

  hideLoading() {
    document.getElementById('loading-screen')?.classList.add('d-none');
  }

  delay(fn, ms = 250) {
    let timer = null
    return (...args) => {
      clearTimeout(timer)
      timer = setTimeout(() => fn.apply(this, args), ms)
    }
  }
}
